module.exports = __webpack_public_path__ + "img/historicalPlans.c916613d.svg";